export default __webpack_public_path__ + "static/media/unknown.cea94353.svg";